const { icons } = require('./constant');

const bank = {
	id: 'bank_master',
	title: 'Bank',
	type: 'collapse',
	icon: icons.IconBranch,
	children: [
		{
			id: 'ifsc',
			title: 'IFSC',
			type: 'item',
			url: '/ifsc',
			icon: icons.WatchLaterOutlinedIcon,
			breadcrumbs: true,
		},
		{
			id: 'admissionStatuses',
			title: 'Admission Statuses',
			type: 'item',
			url: '/admissionStatuses',
			icon: icons.WatchLaterOutlinedIcon,
			breadcrumbs: true,
		},
		{
			id: 'bank_account_type',
			title: 'Bank Account Types',
			type: 'item',
			url: '/bank-account-types',
			icon: icons.WatchLaterOutlinedIcon,
			breadcrumbs: true,
		},
	],
};

export default bank;
